import { AssignmentDocument } from '../Assignment/queryBuilder';
import { AssignmentRoleDocument } from '../AssignmentRole/queryBuilder';
import { EmployeeDocument } from '../Employees/queryBuilder';
import { create } from '../replication-v2/FamilyMember/create';
import { FamilyMember } from '../replication-v2/FamilyMember/FamilyMember';
import { ConfigBuilder, doNotAutoSync, pull, replicate } from '../replication-v2/replicate';
import { RxdbCollectionNameV2 } from '../replication-v2/RxdbCollectionNameV2';
import { AssignmentEmployeeDocument, assignmentEmployeePullQueryBuilder } from './queryBuilder';

export function assignmentEmployeeFamilyMember(
  configBuilder: ConfigBuilder,
  assignment: FamilyMember<AssignmentDocument>,
  assignmentRole: FamilyMember<AssignmentRoleDocument>,
  employees: FamilyMember<EmployeeDocument>,
): FamilyMember<AssignmentEmployeeDocument> {
  const syncConfig = configBuilder<AssignmentEmployeeDocument>(
    RxdbCollectionNameV2.ASSIGNMENT_EMPLOYEE,
  );
  doNotAutoSync(syncConfig);

  pull(syncConfig, assignmentEmployeePullQueryBuilder);

  const replicationState = replicate(syncConfig);
  return create(RxdbCollectionNameV2.ASSIGNMENT_EMPLOYEE, replicationState, [
    assignment,
    assignmentRole,
    employees,
  ]);
}
